export default {
    default: 'An unknown error occured',
    poweredby: 'Powered by <strong>Trendexplorer</strong>, a product of &copy; <em>TRENDONE GmbH</em>',
    home: 'Visit dashboard',
    error: 'Error {code}',
    pageTitle: 'ERROR'
}
